<si-seatsio-seating-chart [config]="mapConfiguration"></si-seatsio-seating-chart>